import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogOut, Home } from 'lucide-react';

const DashboardLayout = ({ children, title }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getRoleBadge = () => {
    const badges = {
      super_admin: { text: 'Super Admin', color: 'var(--accent-purple-400)' },
      admin: { text: 'Admin', color: 'var(--accent-blue-400)' },
      user: { text: 'User', color: 'var(--accent-green-200)' }
    };
    return badges[user?.role] || badges.user;
  };

  const badge = getRoleBadge();

  return (
    <div className="min-h-screen" style={{ background: 'var(--bg-page)' }}>
      {/* Header */}
      <div className="border-b" style={{ background: 'var(--bg-card)', borderColor: 'var(--border-light)' }}>
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between py-4">
            <div className="flex items-center gap-4">
              <Link to="/" className="font-mono text-xl font-semibold" style={{ color: 'var(--text-primary)' }}>
                aithatwows.com
              </Link>
              <span className="px-3 py-1 rounded-full text-xs font-semibold" style={{ background: badge.color, color: 'white' }}>
                {badge.text}
              </span>
            </div>

            <div className="flex items-center gap-4">
              <div className="text-right">
                <div className="body-small font-semibold">{user?.full_name}</div>
                <div className="caption" style={{ color: 'var(--text-muted)' }}>{user?.email}</div>
              </div>
              <Link to="/" className="btn-nav">
                <Home size={18} />
              </Link>
              <button onClick={handleLogout} className="btn-secondary flex items-center gap-2">
                <LogOut size={18} />
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-8">
        {title && <h1 className="heading-1 mb-8">{title}</h1>}
        {children}
      </div>
    </div>
  );
};

export default DashboardLayout;